module.exports = __webpack_public_path__ + "static/media/website-link-CTR.d75cd653.png";